export const CONFIG_PAGE_TYPE_PLP = 'plp';
export const URGENCY_NUDGE_REMOTE_CONFIG = 'urgencyNudge';
export const DEVICE_OS_KEY = 'device_os';
export enum DEVICE_OS_VALUE {
  DESKTOP = 'desktop',
  MOBILE = 'mweb',
}
